var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SafeDetails } from './Safe';
import { Body } from '../../root/PageRouter';
import { Card } from '../../common/card';
export default function CanceledSafe(props) {
    return (_jsx(Body, { children: _jsx(Card, __assign({ "data-test": "CARD" }, { children: _jsx(SafeDetails, { safe: props.safe }, void 0) }), void 0) }, void 0));
}
//# sourceMappingURL=CanceledSafe.js.map